import { useMemorizeFilters } from 'hooks/useMemorizeInputsFilters';
import React, { useCallback, useEffect, useState } from 'react';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { useRecordTypesByUser } from 'views/RecordType/hooks/useRecordTypesByUser';
import Loader from 'components/Loader';
import NotPurchasedList from './components/NotPurchasedList';
import SimpleHeader from 'components/Headers/SimpleHeader';
import NotPurchasedHeader from './components/NotPurchasedHeader';
import { Card, CardBody, Container, Row } from 'reactstrap';

/**
 * @typedef RecordType
 * @property {number} id
 * @property {String} name
 * @property {boolean} active
 * @property {number | null} lead_process_id
 * @property {number | null} sales_process_id
 * @property {number | null} protocol_process_id
 * @property {boolean} is_sla_active
 * @property {boolean} should_send_notification_to_supervisor
 * @property {boolean} should_send_notification_to_attendant
 * @property {boolean} should_send_notification_to_client
 * @property {boolean} movement_alert
 * @property {boolean} sla_time_alert
 * @property {boolean} opening_or_closing_alert
 * @property {boolean | null} accepts_duplicates_creation
 */

export function NotPurchasedReport() {
  /**
   * @type {[Nullable<RecordType>, React.Dispatch<React.SetStateAction<Nullable<RecordType>>>]}
   */
  const [selectedRecordType, setSelectedRecordType] = useState(null);

  /**
   * @type {{ recordTypes: Array<RecordType>, isLoadingRecordTypes: boolean, getRecordTypesByUser: (string) => Array<RecordType>}}
   */
  const { recordTypes, isLoadingRecordTypes, getRecordTypesByUser } =
    useRecordTypesByUser(entitiesName.ACCOUNT);
  const { getMemorizedFilters } = useMemorizeFilters(
    'CRM - NotPurchasedReport'
  );

  useEffect(() => {
    getRecordTypesByUser();
  }, [getRecordTypesByUser]);

  useEffect(() => {
    if (recordTypes && recordTypes.length) {
      const merorizedRecordType = getMemorizedFilters();
      if (!merorizedRecordType?.recordTypeId) {
        setSelectedRecordType(recordTypes[0]);
        return;
      }
      const recordType = recordTypes.find(
        (rt) => rt.id === merorizedRecordType.recordTypeId
      );
      if (!recordType) {
        setSelectedRecordType(recordTypes[0]);
        return;
      }

      setSelectedRecordType(recordType);
    }
  }, [getMemorizedFilters, recordTypes]);

  const handleSelectRecordType = useCallback(
    (recordTypeId) => {
      setSelectedRecordType(recordTypes.find((rt) => rt.id === recordTypeId));
    },
    [recordTypes]
  );

  const getChildToRender = () => {
    if (isLoadingRecordTypes) {
      return (
        <div className="col-12">
          <Row className="justify-content-md-center">
            <Loader />
          </Row>
        </div>
      );
    }

    if (!recordTypes && !isLoadingRecordTypes) {
      return (
        <div>
          <span className="small">
            Você não tem acesso a nenhum tipo de contato.
          </span>
        </div>
      );
    }

    return (
      <NotPurchasedList
        selectedRecordTypeId={selectedRecordType?.id}
        setSelectedRecordType={setSelectedRecordType}
        recordTypes={recordTypes}
      />
    );
  };

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath="/admin"
        showBackArrow="not"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <NotPurchasedHeader
                  title="Relatório de Ausência de Compras"
                  recordTypes={recordTypes}
                  selectedRecordType={selectedRecordType}
                  handleSelectRecordType={handleSelectRecordType}
                />
                <CardBody className="pt-2">{getChildToRender()}</CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
